import axios from 'axios'

export default {
    getGptResponse(question) {
        return axios.post(`/unauthenticated/medgpt/medical-question`, { question })
    },
}
